/**
 * WISHLIST PRODUCT SELECTION
 * 
 * module de gestion des selection 
 * de produit (ajout/remove)
 * depuis des pages du sites
 *  - pages produits
 *  - page resultats de recherche
 *  - pages listes de produits
 */
import $ from "jquery";
import { services } from "../../../../helpers/service";
import { dialog } from "../../../../components/dialog";
import { tpl } from "../../../../helpers/tpl";
import { slider } from "../../../../components/slider";
const utils = require('../utils').default;

const WLProductSelection = (() => {
    const DOM_WISHLIST_PRODUCT_SELECTION = '.js-wishlist-product-selection';
    const DOM_MOVE_PRODUCT_IN_WISHLIST = '.js-wishlists-list-product-move';
    const POPIN_WISHLIST_PRODUCT_SELECTION_ADDED = 'popin-wishlist-product-selection-added';
    const DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN = `[data-js-dialog-id="${POPIN_WISHLIST_PRODUCT_SELECTION_ADDED}"]`;
    const DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN_CAROUSEL = `${DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN} #popin-carousel`;

    const POPIN_WISHLIST_PRODUCT_SELECTION_LIST_SELECT = 'popin-move-product-in-wishlist';
    const DOM_WISHLIST_PRODUCT_SELECTION_LIST_SELECT_POPIN = `[data-js-dialog-id="${POPIN_WISHLIST_PRODUCT_SELECTION_LIST_SELECT}"]`;

    const TXT_TARIF_PRO = 'Tarif professionnel de référence HT';
    const TXT_TARIF_PART = 'Prix conseillé TTC';
    const TXT_TITLE_LIST_SELECT = 'Ajouter ce produit à une liste';

    /**
     * CAROUSEL ACCESS INIT
     * 
     * maj du lien du bon 'acceder à ma liste' de la 
     * popin
     */
    const wishlistAccessInit = (list = undefined) => {
        let btnWishlistAccess = $(`${DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN} .js-wishlist-access`);
        let btnWishlistAccessHref = '/liste-materiel?wishlistid=liste-de-materiel';
        if (utils.getContext() === 'pro') {
            if (utils.userLogged()) {
                list = list != undefined ? list : 'liste-de-materiel'
                btnWishlistAccessHref = '/pro/mon-compte/wishlist/detail?wishlistid=' + list;
            } else {
                btnWishlistAccessHref = `/pro${btnWishlistAccessHref}`;
            }
        }
        btnWishlistAccess.attr('href', btnWishlistAccessHref);
    };
    /**
     * CAROUSEL GENERATION
     * 
     * génération via template du carousel
     * @param {array} items 
     */
    const carouselGeneration = (items) => {
        $(DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN)[0].classList.remove('c-dialog--small');
        $(DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN)[0].classList.add('c-dialog--large');
        utils.debug('WL Carousel generation ', { items });
        const container = $(DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN)[0].querySelector('[data-js-carousel-complementary-products]');
        if (!container) return;
        container.innerHTML = tpl.get({}, 'tpl-complementary-products');
        const itemsWrapper = container.querySelector('[data-js-carousel-complementary-products-items]');
        
        items.forEach((item, index) => {
            const cardHTML = tpl.get({
                'index': index,
                'position': index + 1,
                'total': items.length,
                'title': item.label,
                'link': item.href,
                'imgSrc': item.media,
                'imgAlt': `produit à associé : ${item.label}`,
            }, 'tpl-complementary-products-item');
            itemsWrapper.insertAdjacentHTML('beforeend', cardHTML);
        });
        slider.add(container.querySelector('[data-js-component="slider"]'));
    };
    /**
     * PRODUCT SELECTION
     * 
     * gestion de la selection
     *  - si pro connected => affichage de la popin de choix de liste
     *  - si produit déjà dans la WL => suppression
     *  - sinon => ajout
     * @param {event} event 
     */
    const productSelection = (event) => {
        event.preventDefault();
        let ean = parseInt($(event.currentTarget).attr('data-product-id'));
        let name = $(event.currentTarget).attr('data-product-name');
        let cat = $(event.currentTarget).attr('data-product-cat');
        let price = $(event.currentTarget).attr('data-product-price');
        let list = window.WL.getDefaultListName();
        if (utils.userLogged() && utils.getContext() === 'pro' && window.WL.getWishlistAllListsCount() > 1) { // pro logged aff choix de la liste avant ajout
            productSelectionProListSelection(ean, name, cat , price);
        } else if (event.target.matches('[data-wishlist-add-to-state="selected"]')) {
            productSelectionRemove(ean).then(() => {
                selectProductsInDom();
                utils.dispatchCustomEvent('TRACKERS_WISHLIST_PRODUCT_DELETE', {
                    productLabel: name,
                    productsCount: window.WL.getProductsQuantityTotal(),
                    grandTotal: utils.getFormatedPrice(window.WL.getWishlistGrandTotal()),
                });
                const product = window.WL.getWishlistFlattenProduct(ean, name, cat , price, 1);
                utils.dispatchCustomEvent('TRACKER_WISHLIST_PRODUCTS_REMOVE_FROM_CART', {
                    listLabel: list,
                    listCategory: utils.getContext(),
                    products: [product]
                });
            });
        } else {
            productSelectionAdd(ean, window.WL.getDefaultListName(), price).then(() => {
                productSelectionAddComplete(ean, name, cat , price, list);
            });
        }
    };
    /**
     * PRODUCT SELECTION ADD
     * 
     * ajout d'un produit et appel d'un service
     * pour la création du carousel
     * @param {number} ean 
     * @param {string} list 
     * @returns {Promise}
     */
    const productSelectionAdd = (ean, list , price) => {
        return new Promise((resolve, reject) => {
            window.WL.addToWishlist(ean, list,utils.getContext(), price).then(() => {
                utils.debug('WL PRODUCT SELECTION ADD', { ean, list , price });
           
                services.use('wishlistpopinaddto', { "refs": [ean], "context": utils.getContext() }, false).then(function (result) {
                    utils.debug('WL PRODUCT SELECTION ADD return', { result });
                    if (result != undefined && result.datas != undefined) {
                        if (result.datas.elements != undefined) {
                            carouselGeneration(result.datas.elements);
                        }
                        if (result.datas.name != undefined) {
                            $(DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN).find('.popin-content-wrapper .ref').html(result.datas.name);
                        }
                    }
                    wishlistAccessInit(list);

                })
                .catch((error) => {
                    console.error(error);
                    dialog.error('Une erreur est survenue lors de l\'ajout du produit à la liste de souhaits');
                });
                resolve();
            });
        });
    };
    /**
     * PRODUCT SELECTION ADD COMPLETE
     * 
     * @param {string} name 
     * @param {string} cat 
     */
    const productSelectionAddComplete = (ean, name, cat , price, list) => {
        selectProductsInDom();
        dialog.close(POPIN_WISHLIST_PRODUCT_SELECTION_LIST_SELECT);
        dialog.open(POPIN_WISHLIST_PRODUCT_SELECTION_ADDED);
        // $(`${DOM_WISHLIST_PRODUCT_SELECTION_LIST_SELECT_POPIN} .popin-close`).trigger('click');
        // $(DOM_WISHLIST_PRODUCT_SELECTION_ADDED_POPIN).addClass('active');
        let isComparateur = ($('#comparateur').length === 1);
        utils.dispatchCustomEvent('TRACKERS_WISHLIST_PRODUCT_ADD', {
            event: isComparateur ? 'addProductFromComparatorToWishlist' : 'wishlistIcon',
            eventCategory: isComparateur ? 'Comparator' : 'wishlist',
            eventLabel: cat,
            eventValue: name,
        });
        const product = window.WL.getWishlistFlattenProduct(ean, name, cat , price, 1);
        utils.dispatchCustomEvent('TRACKER_WISHLIST_PRODUCTS_ADD_TO_CART', {
            listLabel: list,
            listCategory: utils.getContext(),
            products: [product]
        });
    };
    /**
     * PRODUCT SELECTION ADD EVENTS
     * 
     * bind des events
     */
    const productSelectionAddEvents = () => {
        $(`${DOM_MOVE_PRODUCT_IN_WISHLIST} a`).off().on('click', function (event) {
            event.preventDefault();
            let ean = parseInt($(this).attr('data-product-id'));
            let name = $(this).attr('data-product-name');
            let cat = $(this).attr('data-product-cat');
            let list = $(this).attr('data-list-id');
            let price = $(this).attr('data-product-price');
            productSelectionAdd(ean, list, price).then((success) => {
                productSelectionAddComplete(ean, name, cat , price, list);
            });
        });
    };
    /**
     * PRODUCT SELECTION REMOVE
     * 
     * @param {number} ean 
     * @returns {Promise}
     */
    const productSelectionRemove = (ean) => {
        return new Promise((resolve, reject) => {
            window.WL.removeFromWishlist(ean, window.WL.getDefaultListName()).then(() => {
                utils.debug('WL PRODUCT SELECTION REMOVE', ean);
                resolve();
            });
        });

    };
    /**
     * PRODUCT SELECTION LIST UPDATE
     * 
     * listern de mise à jour
     */
    const productSelectionListUpdate = () => {
        document.addEventListener('MOVE_PRODUCT_IN_WISHLIST_UPDATES', (event) => {
            productSelectionAddEvents();
        });
    };
    /**
     * PRODUCT SELECTION PRO LIST SELECTION
     * 
     * initialisation des params/event pour l'ajout
     * de produits via popin liste de WL
     * @param {number} ean 
     * @param {string} name 
     * @param {string} cat 
     */
    const productSelectionProListSelection = (ean, name, cat , price) => {
        $(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`)
            .attr('data-type', 'add_to_wishlist')
            .attr('data-product-id', ean)
            .attr('data-product-name', name)
            .attr('data-product-cat', cat)
            .attr('data-product-price', price);
        utils.dispatchCustomEvent('WISHLIST_PRODUCT_MOVE_POPIN_OPEN');
        utils.dispatchCustomEvent('WISHLIST_CREATE_POPIN_OPEN');
        $(`${DOM_WISHLIST_PRODUCT_SELECTION_LIST_SELECT_POPIN} [data-js-dialog-title]`).text(TXT_TITLE_LIST_SELECT);
        dialog.open(POPIN_WISHLIST_PRODUCT_SELECTION_LIST_SELECT);
        // $(DOM_WISHLIST_PRODUCT_SELECTION_LIST_SELECT_POPIN).addClass('active');
        $(`${DOM_MOVE_PRODUCT_IN_WISHLIST} button`).off().on('click', (event) => {
            event.preventDefault();
            let ean = parseInt($(event.currentTarget).attr('data-product-id'));
            let name = $(event.currentTarget).attr('data-product-name');
            let cat = $(event.currentTarget).attr('data-product-cat');
            let list = $(event.currentTarget).attr('data-list-id');
            productSelectionAdd(ean, list , price).then(() => {
                productSelectionAddComplete(ean, name, cat , price, list);
            });
        })
    };
    /**
     * SELECT PRODUCTS IN DOM
     * 
     * selection des buttons d'ajout à la 
     * WL de la page et add/remove de l'état
     * inWshlist
     * @returns 
     */
    const selectProductsInDom = () => {
        let currentWlProducts = JSON.parse(JSON.stringify(window.WL.getWishlist().list));
        if (utils.isProContext() && utils.userLogged()) {
            let allWishLists = window.WL.getWishlistAllLists('pro');
            for (let key in allWishLists) {
                if (key !== utils.slug(window.WL.getDefaultListName())) {
                    allWishLists[key].list.forEach(element => {
                        currentWlProducts.push(element);
                    });
                };
            }
        }
        $(DOM_WISHLIST_PRODUCT_SELECTION).each(function () {
            let productId = parseInt($(this).attr('data-product-id'));
            if (currentWlProducts.filter((product) => productId === product.ean).length) {
                $(this).attr('data-wishlist-add-to-state', 'selected');
                $(this).attr('aria-label', $(this).find('span.c-wishlist-add-to__selected').text());
            } else {
                $(this).attr('data-wishlist-add-to-state', 'not-selected');
                $(this).attr('aria-label', $(this).find('span.c-wishlist-add-to__not-selected').text());
            }
        });
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('DOCS PRODUCTS SELECTION', 'initialisation');
        selectProductsInDom();
        productSelectionListUpdate();
        $(DOM_WISHLIST_PRODUCT_SELECTION).off().on('click', productSelection);
    };
    return { init };
})();
export default WLProductSelection;